import { render, staticRenderFns } from "./principleBalanceIsZero.vue?vue&type=template&id=121c3ce9&"
import script from "./principleBalanceIsZero.vue?vue&type=script&lang=js&"
export * from "./principleBalanceIsZero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports